export default __webpack_public_path__ + "static/alexandru-david-dbb3dfdf142ee656fc1c6f6057ce3f43.jpg";